module.exports = __webpack_public_path__ + "img/hogcone_logo.493cc44.png";